import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-img-viewer-modal',
  standalone: true,
  templateUrl: './img-viewer-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImgViewerModalComponent {
  readonly activeModal = inject(NgbActiveModal);

  @Input() src!: string;
}
